
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import * as _ from 'lodash';

@Component({
  selector: 'app-select-attachgroup',
  templateUrl: './select-attachgroup.component.html',
  styleUrls: ['./select-attachgroup.component.scss']
})
export class SelectattachgroupComponent implements OnInit {

  

  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() title: string = "選擇附加品項群組"; 
  mainDataList: Array<any>; //已選資料
  infoList: Array<any>;     //選項資料
  showList: Array<any>;     //顯示資料
  @Input() info : {//其他設定
    IsLoding:boolean
    ORG_Company_ID: number,
    ORG_Store_ID: number,
  };  
  query : {  //查詢選項
    searchKey : string
  } 
  status: { //當前狀態
    isSelectAll : boolean //是否已全選
    showType:number // 顯示有選過的
  }
  list={
    showType : [
      {name:"全部",value:0},
      {name:"已選",value:1},
      {name:"未選",value:2}]
  }
  modalRef = null;  //談窗鉤子

  //查詢的門市
  storeSelectList: selectData[];
  selectORG_Store_ID: number;
  

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
  ) {

   }

  //info 資料來源 = callAPI / 外部丟入
  //data 來源 =  MainData[ListName]
  
  //全選功能:
  // 撈取全部資料以提供全選 -  那麼分頁將不再重要 : 建議改成設定欄位
  // 全選讀取設定，非全選讀取陣列 
  // 同上問題，在經過搜尋之後的全選將有所刪減，因此除了"全選設定欄位"，還要加上查詢欄位，在後端進行查詢
  // 同上問題，過程中的其他方的新增，可能導致有額外資料產生。
  // 但不管是丟設定到後端查後取資，一開始取全資但顯示還是每頁只抓當頁資料，都可能造成以上問題。
  // 因此最佳處理還是一開始就丟出全部到前端顯示。 但如此行為可能導致效能緩慢? 
  // 單頁全選-可以正常運作

  ngOnInit(): void {
   this.query = { searchKey :""}   
  }

  ngAfterViewInit(){   
    this.onOpen(this.info, this.orgData)
  }


 //取得門市清單 API
 getStoreList() {//取得門市清單 USP_YOPOSWebGetStoreList

    



  this.http.post<any>('api/ORGStore/StoreList', {

    ORG_Company_ID: this.info.ORG_Company_ID,
    ORG_Store_ID: this.info.ORG_Store_ID,
  }).subscribe({
    next: data => {

      this.storeSelectList = [];


      //門市共用下拉選單
      let Item :any= {};
      Item.value = 0;
      Item.content = '總部';
      this.storeSelectList.push(Item);
  
      if(this.info.ORG_Store_ID ){
  
           //門市共用下拉選單
           let Item :any= {};
           Item.value = this.info.ORG_Store_ID;
           Item.content = data.LIST.find(x=>x.ORG_Store_ID == this.info.ORG_Store_ID ).StoreName;
           this.storeSelectList.push(Item);
  
      }else{

        data.LIST.forEach(element => {
          //門市共用下拉選單
          var selectItem = new selectData();
          selectItem.value = element.ORG_Store_ID;
          selectItem.content = element.StoreName;
          this.storeSelectList.push(selectItem);
        });
  
  
      }
    

      

      


      // 預設點第一個
      if (this.storeSelectList.length > 0) {
        this.selectORG_Store_ID = this.storeSelectList[0].value
      }
    },
    error: error => {
      console.error('There was an error!', error);
    }
  });

}



  //打開選擇附加品項

  @ViewChild('Modal') Modal :TemplateRef<any>
  onOpen(info,data) {
    this.getStoreList()

    if(info){
      this.info = info
    }
    if(data){
      this.orgData = data
    }
      
    //初始化查詢資料
    this.query.searchKey = ""
    this.mainDataList = []
    this.status= { 
      isSelectAll : true,
      showType:0
    }
    
    //處理已選資料
    if(this.orgData && this.orgData.length > 0){      
      this.mainDataList = _.cloneDeep(this.orgData)      
    }else{
      this.mainDataList = []
    }    
    
    //撈取可選資料 並合成已選資料
    this.onQuery() 

    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  //查詢
  onQuery( ) {
    
    this.getInfoList((data)=>{
      
      
      
      //初始化
      this.infoList = data
      this.showList = data
     

      this.showList.forEach(x => {

        let obj = _.find(this.mainDataList, y => this.judgeSame(y,x))
        if (obj) {
          x.isSelect = true
        } else {
          x.isSelect = false
        }
      })

      this.filterShowType()
      this.judgeSelectAll()

    });

  }

  onShowType(){
    this.filterShowType()
    this.judgeSelectAll()
  }

  //選擇
  onSelect(isAdd:boolean, item ) {
    if(isAdd){
      item.isSelect = true
      item.Sorting = 0
      this.mainDataList.push(item);

    }else{
      item.isSelect = false
      let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
      this.mainDataList.splice(index, 1);
    }    

    this.judgeSelectAll()
  }

  //全選
  onSelectAll(){
    
    
    if(this.status.isSelectAll){
      this.showList.forEach(item=>{
        item.isSelect = false
        let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
        this.mainDataList.splice(index, 1);
      })
    }
    else{      
      this.showList.forEach(item=>{
        item.isSelect = true
        item.Sorting = 0
        this.mainDataList.push(item);
      })
    }
    
    this.status.isSelectAll = !this.status.isSelectAll
  }

  //處存
  onSave() {
    

    this.orgData = [];
    let i = 1;
    this.mainDataList.forEach(x=>{      
      x.Sorting = i;
      i++
      this.orgData.push(x)
    })

    
    this.emitList.emit(this.orgData)
    this.modalRef.close()


  

  }




  


  //------------------------------------------------------------------------------------------
  

  //過濾已選未選等
  filterShowType(){
    if(this.status.showType==0){
      this.showList = _.concat([],this.infoList)
    }
    else if(this.status.showType==1){
      this.showList = _.filter(this.infoList,x=>x.isSelect)
    }
    else{
      this.showList = _.filter(this.infoList,x=> !x.isSelect)
    }
  }




  //判斷是否全選
  judgeSelectAll(){
    if(!this.showList || this.showList.length==0){
      return true
    } 
  
    this.status.isSelectAll = this.showList.every(x=>{
      return this.mainDataList.some(y=>this.judgeSame(y,x))    
    })
    

  }




  //----------------------------------------客製化--------------------------------------------------


    //比較
    judgeSame(y , x){
      return y.PRDMenuAttachItemGroupNo == x.PRDMenuAttachItemGroupNo 
      
    }


  //取得選擇附加品項清單 API
  getInfoList( callback) {
    //取得含有商品的附加品項
    this.info.IsLoding= true
    this.http.get<any>(
      `api/AttachItemSetting/GetAttachItemListByAll?` +        
      `ORG_Company_ID=${this.info.ORG_Company_ID}`+
      `${this.selectORG_Store_ID !=null ? "&CreateStore=" + this.selectORG_Store_ID : ''}`+
      ((this.query.searchKey == null || this.query.searchKey == '') ? '' : ('&keyword=' + this.query.searchKey)) +
      '&IsDelete=' + false +'&Page=' + 1+'&PerPage=' + 2147483647
    ).subscribe({
      next: data => {

        if(callback)
          callback(data.LIST)

        this.info.IsLoding= false

      },
      error: error => {
        console.error('取得附加品項群組清單出錯', error);
        this.info.IsLoding= false

      }
    });

  }







  
  
}

class selectData {
  value: number;//
  content: string;//
  info:string
}
